import { create } from "zustand"
import { persist } from "zustand/middleware"
import { resetSupportChat } from "../lib/chatwoot"
import { clearAuthDraft } from "../lib/authDraft"
import { User } from "../types/entities/user"

type UserState = {
    user: User | null
    deviceToken: string | null
    unreadMessages: number
}

type UserActions = {
    setDeviceToken: (deviceToken: string | null) => void
    setUser: (user: User | null) => void
    setUnreadMessages: (count: number) => void
    clearAuth: () => void
    getToken: () => string | null
}

export const userStore = create<UserState & UserActions>()(
    persist(
        (set, get) => ({
            user: null,
            deviceToken: null,
            unreadMessages: 0,

            setDeviceToken: token => set({ deviceToken: token }),
            setUser: user => set({ user }),
            setUnreadMessages: count => set({ unreadMessages: Math.max(0, count) }),
            clearAuth: () => {
                resetSupportChat()
                // Неудалённый черновик авторизации откроет старый шаг (например, Telegram) при следующем входе
                clearAuthDraft()
                // Важно: чтобы не получать уведомления "чужого" профиля после разлогина/смены пользователя
                set({ user: null, deviceToken: null, unreadMessages: 0 })
            },

            getToken: () => get().user?.token ?? null
        }),
        {
            name: "user-store",
            partialize: state => ({
                user: state.user,
                deviceToken: state.deviceToken
            })
        }
    )
)
